import React from "react";
import { Jumbotron } from "./migration";

const MainBody = React.forwardRef(
  ({ title, message, avatar, email }, ref) => {
    return (
      <Jumbotron fluid id="home" className="hero m-0">
        <div className="text-center">
          {avatar && (
            <img src={avatar} alt="" className="hero-avatar mb-4" />
          )}
          <h1 ref={ref} className="hero-title">
            <span className="hero-greeting">Hi, I'm</span> {title}
          </h1>
          <p className="lead hero-subtitle">{message}</p>
          {email && (
            <a className="hero-email" href={`mailto:${email}`}>
              {email}
            </a>
          )}
        </div>
      </Jumbotron>
    );
  }
);

export default MainBody;
